module.exports = __webpack_public_path__ + "img/shop6de.ec4baee6.png";